/**
 * "Anyone with the link" viewing. A share page lives under /share/<token>/…; the token is the
 * visitor's only credential and travels to the server as a request header on every GraphQL call.
 *
 * Derived from the current URL on every read rather than cached: the Apollo link (created once,
 * outside React) has to see it, and a visitor who navigates to /login inside the SPA must stop
 * sending it at once, or the server keeps treating their fresh session as a share visit.
 */
const SHARE_PATH_PREFIX = '/share/';

/** Header the server reads the token from (mirrors SHARE_TOKEN_HEADER in apps/server). */
export const SHARE_TOKEN_HEADER = 'x-share-token';

const readTokenFromLocation = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  const path = window.location.pathname;
  if (!path.startsWith(SHARE_PATH_PREFIX)) return undefined;
  const token = path.slice(SHARE_PATH_PREFIX.length).split('/')[0];
  return token || undefined;
};

export const getShareToken = () => readTokenFromLocation();

/** True while the page is on a share-link URL: no session, read-only, one project. */
export const isShareMode = () => readTokenFromLocation() !== undefined;

/** The link a project manager copies and hands out. */
export const buildShareUrl = (token: string) => `${window.location.origin}${SHARE_PATH_PREFIX}${token}`;

/** Where the share page routes itself once the token is resolved; mirrors the normal project URL so every useParams() consumer keeps working. */
export const sharedProjectPath = ({ token, organisationId, projectId }: { token: string; organisationId: string; projectId: string }) => `${SHARE_PATH_PREFIX}${token}/organisations/${organisationId}/projects/${projectId}`;
